<div class="modal-header">
    <h2 class="modal-title font-weight-bold" id="displayName" *ngIf="ps">
        {{ "SUPER-ADMIN.PS.MODALS.UPDATE-PS.TITLE" | translate }} <h4>{{ps?.lname}} {{ps?.fname}} ({{ps?.email}})</h4>
    </h2>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
        <span aria-hidden="true">&times;</span>
    </button>    
</div>

<div class="modal-body">
    <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
    <form [formGroup]="psUpdateForm"
        novalidate #formDirective="ngForm" (ngSubmit)="updatePS(psUpdateForm.value)">
        <div class='form-row mb-3 border-bottom  my-row'>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field class="mx-2">
                    <mat-label>{{ "FORM.CIVILITE-SELECT" | translate }}</mat-label>
                    <mat-select placeholder="{{ 'FORM.CIVILITE-SELECT' | translate }}" formControlName="civilite">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let civ of civiliteTab" [value]="civ.id">
                            {{ civ.libelle }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.LNAME' | translate }}"
                    formControlName="lname" id="lname">
                </mat-form-field>

                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.FNAME' | translate }}"
                    formControlName="fname" id="fname">
                </mat-form-field>
            </div>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.PHONE' | translate }}"
                    formControlName="phoneNumber" id="phoneNumber">
                    <mat-error *ngIf="hasError('phoneNumber','forbidden')">
                        {{ "ERRORS.PHONE-INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="mx-2">
                    <mat-select [formControl]="clientMultiCtrl" placeholder="Clients" [multiple]="true" #multiSelect>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="clientMultiFilterCtrl"
                                placeholderLabel="{{ 'FORM.SELECT.CLIENT.SEARCH' | translate }}"
                                noEntriesFoundLabel="{{ 'FORM.SELECT.CLIENT.NO-FOUND' | translate }}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let client of filteredClientsMulti | async" [value]="client">
                            {{client.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('clients','required')">
                        {{ "ERRORS.CLIENT-REQUIRED" | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="form-row my-row">
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <h4>
                    {{ 'FORM.PS.TITLE-RESPONSABLE' | translate }}
                </h4>
                <mat-form-field class="mx-2">
                    <mat-label>{{ 'FORM.SELECT.RESPONSABLE.LABEL' | translate}}</mat-label>
                    <mat-select formControlName="responsable"
                    placeholder="{{ 'FORM.SELECT.RESPONSABLE.LABEL' | translate}}">
                        <mat-option value="false">{{ 'FORM.SELECT.RESPONSABLE.NO' | translate }}</mat-option>
                        <mat-option value="true">{{ 'FORM.SELECT.RESPONSABLE.YES' | translate }}</mat-option>
                    </mat-select>
    
                    <mat-error *ngIf="hasError('responsable','required')">
                        {{ "ERRORS.RESPONSABLE-REQUIRED" | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <ng-container *ngIf="psUpdateForm.value.responsable == 'true' || psUpdateForm.value.responsable == true">
            <div class="form-row my-row">
                <div class='col-6 col-lg-auto pb-1 my-col'>
                    <mat-form-field class="mx-2">
                        <input matInput type="text" placeholder="{{ 'FORM.RES-EMAIL' | translate }}"
                        formControlName="res_email" id="res_email">
                        <mat-error *ngIf="hasError('res_email','required')">
                            {{ "ERRORS.RESPONSABLE-EMAIL-REQUIRED" | translate }}
                        </mat-error>
                        <mat-error *ngIf="hasError('res_email', 'pattern')">
                            {{ "ERRORS.MAIL-INVALID" | translate }}
                        </mat-error>
                    </mat-form-field>
            
                    <mat-form-field class="mx-2">
                        <input matInput type="text" placeholder="{{ 'FORM.RES-IDENTIFIANT' | translate }}"
                        formControlName="res_identifiant" id="res_identifiant">
                        <mat-error *ngIf="hasError('res_identifiant','required')">
                            {{ "ERRORS.RESPONSABLE-IDENTIFIANT-REQUIRED" | translate }}
                        </mat-error>
                    </mat-form-field>
            
                    <mat-form-field class="mx-2">
                        <input matInput type="text" placeholder="{{ 'FORM.RES-DESCRIPTION' | translate }}"
                        formControlName="res_description" id="res_description">
                        <mat-error *ngIf="hasError('res_description','required')">
                            {{ "ERRORS.RESPONSABLE-DESCRIPTION-REQUIRED" | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <div class='form-row pt-3 my-row'>
            <div class='col my-col'>
                <button type="submit" class="btn btn-primary mx-1" [disabled]="!psUpdateForm.valid">
                    {{ "BUTTONS.UPDATE" | translate }}
                </button>
                <button type="button" class="btn btn-danger" (click)="activeModal.close('')">
                    {{ "BUTTONS.CLOSE" | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
